import { useDispatch } from 'react-redux';

import useUsageCount from '@app/hooks/useUsageCount';
import embeddedService from '@app/libs/embedded/embeddedService';
import { checkSigningRequestAuthority } from '@app/store/user/authority/actions';

export function useCheckSigningRequestAuthority() {
  const dispatch = useDispatch();
  const { apiSigningRequestCount, signingRequestCount } = useUsageCount();

  async function checkAuthority(workspaceId: string) {
    const ticketCheckResult = await dispatch(checkSigningRequestAuthority({ workspaceId }));

    if (checkSigningRequestAuthority.rejected.match(ticketCheckResult)) {
      // TODO: #9103 이슈 결정사항에 따라 에러처리 방향 통일하기
      throw new Error(ticketCheckResult.error.message);
    }

    const isAvailableToUseSigningRequest: boolean = embeddedService.isEmbedded
      ? apiSigningRequestCount.limit - apiSigningRequestCount.usage > 0
      : signingRequestCount.limit - signingRequestCount.usage > 0;

    if (!isAvailableToUseSigningRequest) {
      // TODO: #9103 이슈 결정사항에 따라 에러처리 방향 통일하기
      throw new Error('가지고 있는 요금제를 모두 사용하였습니다.\n 새로운 요금제를 구매해 주세요.');
    }
  }
  return {
    checkAuthority,
  };
}
